/* eslint semi:0 */
import component from 'utils/component'
import BrightcoveCoverPlayerVm from 'vms/brightcoveCoverPlayerVm'
import BrightcovePlayerView from 'views/BrightcovePlayerView'
import BrightcoveBasePlayerController from 'controllers/BrightcoveBasePlayerController'

class BrightcoveCoverPlayerController extends BrightcoveBasePlayerController {
  get vmClass() { return BrightcoveCoverPlayerVm }
}

export default component.make(BrightcoveCoverPlayerController, BrightcovePlayerView)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/brightcoveCoverPlayerComponent.js